// @flow
import { COUNTRY_INTRODUCTION } from 'Client/cms/toolkit/constants';
import { CountryIntroductionLine } from 'Components/lines/country-introduction-line/CountryIntroductionLine';
import { countryIntroductionResolver } from './countryIntroduction.resolver';

export const countryIntroductionDescriptor = {
  name: COUNTRY_INTRODUCTION,
  component: CountryIntroductionLine,
  resolve: countryIntroductionResolver.resolve,
};
